import {
  Component,
  HostListener,
  OnInit,
  Pipe,
  ViewChildren,
} from "@angular/core";
import { AnimationItem } from "lottie-web";
import { AnimationOptions, LottieComponent } from "ngx-lottie";

@Component({
  selector: "app-eurekacards",
  templateUrl: "./eurekacards.component.html",
  styleUrls: ["./eurekacards.component.scss"],
})
export class EurekacardsComponent implements OnInit {
  // @ViewChildren(LottieComponent) ngLottie: LottieComponent[];
  animations: AnimationItem[] = [];
  players: LottieComponent[] = [];
  // dataRoadmap: any = [
  //   {
  //       id: 1,
  //       title: 'Networking',
  //       text: 'Network with elite investors and startups, forging valuable connections that drive success',
  //       animationUrl: 'assets/animations/flow1.json',
  //   },
  //   {
  //     id: 2,
  //     title: 'Prizes',
  //     text: 'Compete for cash prizes worth 1 Cr+, providing crucial funding to fuel your entrepreneurial journey',
  //     animationUrl: 'assets/animations/flow2.json',
  //   },
  //   {
  //     id: 3,
  //     title: 'Mentoring',
  //     text: 'Gain insights through personalized guidance from industry experts and seasoned mentors',
  //     animationUrl: 'assets/animations/flow3.json',
  //   },
  //   {
  //     id: 4,
  //     title: 'Workshops',
  //     text: 'Attend transformative workshops led by esteemed startup founders, expanding your knowledge and skills',
  //     imageurl: 'assets/eurekacards/workshop.png'
  //   },
  //   {
  //     id: 5,
  //     title: 'Fundraising',
  //     text: 'Unlock opportunities to secure funding from top VCs and angels, propelling your startup to new heights',
  //     animationUrl: 'assets/animations/flow1.json',
  //   },
  //   {
  //     id: 6,
  //     title: 'Benefits',
  //     text: "Enjoy exclusive perks and offers from renowned companies, maximizing your startup's potential",
  //     imageurl: 'assets/eurekacards/benefits.png'
  //   },
  // ];

  dataRoadmap = [
    {
      id: 0,
      animationUrl: "assets/animations/Networkl.json",
      title: "Networking",
      desc: "Network with leading investors and startups, creating valuable connections to drive success",
    },
    {
      id: 1,
      animationUrl: "assets/animations/flow2.json",
      title: "Prizes",
      desc: "Compete for cash prizes  worth $100,000, offering essential funding to support your entrepreneurial journey",
    },
    {
      id: 2,
      animationUrl: "assets/animations/flow3.json",
      title: "Mentoring",
      desc: "Receive valuable insights through personalized mentorship from industry experts and experienced mentors",
    },
    {
      id: 3,
      animationUrl: "assets/animations/flow6.json",
      title: "Workshops",
      desc: "Participate in transformative workshops led by renowned startup founders, enhancing your knowledge and skills",
    },
    {
      id: 4,
      animationUrl: "assets/animations/Rocket.json",
      title: "Fundraising",
      desc: "Access opportunities to obtain funding from top VCs and angels, taking your startup to new heights",
    },
    {
      id: 5,
      animationUrl: "assets/animations/flow4.json",
      title: "Benefits",
      desc: "Enjoy exclusive perks and offers from renowned companies, maximizing your startup's potential",
    },
  ];
  getLottieOptions(animationUrl: string): AnimationOptions {
    return {
      path: animationUrl, // path to the Lottie animation JSON file
      autoplay: false,
      loop: false,
    };
  }
  constructor() {}

  ngOnInit(): void {}

  animationCreated(
    animation: AnimationItem,
    id: number,
    player: LottieComponent
  ) {
    console.log(animation, id, player);
    this.animations[id] = animation;
    this.players[id] = player;
  }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
    for (let i = 0; i < this.animations.length; i++) {
      if (this.animations[i] && this.players[i]) {
        const { top, bottom, height } =
          this.players[i].container.nativeElement.getBoundingClientRect();

        // if (top < window.innerHeight - height / 2) {
        //   this.animations[i].play();
        // }

        const MAX_TOP = window.innerHeight - (2 * height) / 5;
        const MIN_TOP = Math.max(window.innerHeight / 2 - (3 * height) / 5, 0);

        if (top < MAX_TOP && top >= MIN_TOP) {
          const progress =
            1 - Math.pow((top - MIN_TOP) / (MAX_TOP - MIN_TOP), 2);
          this.animations[i].goToAndStop(
            Math.floor(progress * this.animations[i].totalFrames),
            true
          );
        } else if (top < MIN_TOP) {
          this.animations[i].goToAndStop(this.animations[i].totalFrames, true);
        }
      }
    }
  }
}
